/**
 * PINS constant — filenames of the 30 branded Pinterest pins served under
 * /api/exports/pins/. Each pin is 1000×1500 (2:3 vertical), designed for
 * shareability across Pinterest, Instagram and the site itself.
 *
 * Slug map: the pin filenames follow "pin-NN-{term-slug}.jpg". The map lets
 * TermDetail.jsx look up "does this term have a hero pin?" in O(1).
 */
export const PINS = [
  "pin-01-deglaze.jpg",
  "pin-02-julienne.jpg",
  "pin-03-chiffonade.jpg",
  "pin-04-al-dente.jpg",
  "pin-05-blanch.jpg",
  "pin-06-braise.jpg",
  "pin-07-confit.jpg",
  "pin-08-emulsify.jpg",
  "pin-09-reduce.jpg",
  "pin-10-saute.jpg",
  "pin-11-fold.jpg",
  "pin-12-poach.jpg",
  "pin-13-marinate.jpg",
  "pin-14-roast.jpg",
  "pin-15-baste.jpg",
  "pin-16-caramelise.jpg",
  "pin-17-brine.jpg",
  "pin-18-score.jpg",
  "pin-19-chop.jpg",
  "pin-20-simmer.jpg",
  "pin-21-cure.jpg",
  "pin-22-render.jpg",
  "pin-23-flambe.jpg",
  "pin-24-mise-en-place.jpg",
  "pin-25-mirepoix.jpg",
  "pin-26-aioli.jpg",
  "pin-27-bechamel.jpg",
  "pin-28-roux.jpg",
  "pin-29-risotto.jpg",
  "pin-30-acidulate.jpg",
];

// term-slug → pin filename lookup. Handles the couple of British/US
// aliases (caramelise/caramelize, flambe/flambé, saute/sauté).
const ALIAS = {
  "caramelize": "caramelise",
  "flambé": "flambe",
  "sauté": "saute",
};

export function pinForTerm(slug) {
  if (!slug) return null;
  const clean = String(slug).trim().toLowerCase();
  const canonical = ALIAS[clean] || clean;
  const match = PINS.find((f) => f.endsWith(`-${canonical}.jpg`));
  return match || null;
}

// URL helper — uses the same backend URL the rest of the app uses so it
// works in preview and production without any env-var duplication.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export function pinUrl(filename) {
  return `${BACKEND_URL}/api/exports/pins/${filename}`;
}
